const isIe = () => {
  let rv = -1
  if (navigator.appName == 'Microsoft Internet Explorer') {
    const ua = navigator.userAgent;
    const re = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})")
    if (re.exec(ua) != null)
      rv = parseFloat(RegExp.$1)
  }
  return rv
}
const sound = (() => {
  let browserVer = isIe()
  let bgm;
  let src = '//cdn.jin10.com/assets/media/notice.wav?20170216';
  if (browserVer > -1 && browserVer < 9) {
    document.body.insertAdjacentHTML('beforeend', '<embed id="J_audiotagIE" src="' + src + '" autostart="false" loop="false" width="0" height="0"></embed>')
    bgm = document.getElementById('J_audiotagIE')
  } else {
    bgm = new Audio()
    bgm.src = src
    bgm.loop = false
  }

  return {
    play: function () {
      bgm.loop = typeof loop !== 'undefined' ? loop : false
      bgm.play()
    },
    pause: function () {
      bgm.pause()
    }
  }
})()
export default sound


// WEBPACK FOOTER //
// ./src/views/index/modules/sound.js